let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gkmZg"), load("hs6o8")]).then(() => parcelRequire('kB13O'));